import NavSideBar from "../component/NavSideBar";

export default function Tables() {
  return (
    <NavSideBar>
        <div className="p-10 text-3xl font-bold">Tables</div>
    </NavSideBar>
  )
}
